import React, { useState } from "react";
import { Button, Card, Container, Row, Col, Form, Offcanvas  } from 'react-bootstrap';
import { FaStar, FaUserCircle, FaCheckCircle, FaRegStar } from "react-icons/fa";
import Footer from '../Footer/Footer';
import { Link } from 'react-router-dom';




const ProductDetailedPage = () => {

  const reviews = [
    {
      id: 1,
      name: "John Doe",
      rating: 4.5,
      review:
        "Great software with excellent features. The UI is intuitive and easy to use!",
      date: "March 5, 2025",
    },
    {
      id: 2,
      name: "Sarah Smith",
      rating: 5,
      review: "Amazing experience! Highly recommended for businesses.",
      date: "February 20, 2025",
    },
    {
      id: 3,
      name: "Michael Johnson",
      rating: 4,
      review: "Good tool, but the customer support could be better.",
      date: "January 15, 2025",
    },
  ];





  const [showCanvas, setShowCanvas] = useState(false);
  const handleShow = () => setShowCanvas(true);
  const handleClose = () => setShowCanvas(false);

  const [formData, setFormData] = useState({
    company: "",
    description: "",
    services: [],
    rating: 0
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleRating = (index) => {
    setFormData({ ...formData, rating: index + 1 });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Review Submitted:", formData);
  };






  return (

    <>
      <div className="sub-header sub-search py-3 bg-light border-bottom border-top">
        <Container>
          <Row className="align-items-start">
            <Col md={12}>
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="e.g. App Development, UX Design, IT Services..."
                  className="me-4 px-4 rounded-5"
                  aria-label="Search"
                />
                <Form.Control
                  type="text"
                  placeholder="Enter location"
                  className="me-4 px-4 rounded-5"
                  aria-label="Location"
                />
                <Button variant="primary" className="px-4 rounded-5">Search</Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>

      <section className="page-header bg-skyblue py-2">
        <div className="container pt-4 pb-3">
          <div className="row page-introduction">
            <div className="col-12">
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item small"><a href="#">Home</a></li>
                      <li class="breadcrumb-item small"><a href="#">Banana Accounting</a></li>
                      <li class="breadcrumb-item small active" aria-current="page">Banana Accounting</li>
                    </ol>
                  </nav>

                </div>
                <div>

                <button className='btn btn-link bg-white border-white text-decoration-none me-3 py-2 p-3 text-primary' onClick={() => setShowCanvas(true)} ><i class='bx me-1 text-primary bx-edit-alt' ></i> Write a Review</button>
                  <button className="btn btn-md btn-primary py-2 p-3 me-3">Try Demo</button>
                  <button className='btn btn-outline-primary py-2 p-3 text-primary'>Visit Website <i class='bx text-primary bx-link-external' ></i></button>
                </div>


              </div>
              <div className="d-flex align-items-center justify-content-start">
                <div className="text-start">
                  <img src="https://cryptologos.cc/logos/arbitrum-arb-logo.png" className="img-thumbnail p-3 rounded-3 border-1 me-4" style={{ width: "80px", height: "80px" }} />
                </div>
                <div className="text-start">
                  <h3>Banana Accounting</h3>
                  <span class="card-text rating"><strong class="me-2"> 4.5</strong><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-warning" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-warning" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-warning" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-warning" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" class="text-warning" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg><span class="ms-3 small">(26 Reviews)</span></span>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <div className="product-detailed-page container mt-5">

        <div className="row">
          <div className="col-sm-12">
            <div class="card border rounded-4">
              <div class="card-body p-5 brand-body">
                <h4 class="card-title mb-3">Overview</h4>
                <p class="card-text text-muted">
                  Banana Accounting is an incredible accounting tool for startups, established business associations, and individuals. More than spreadsheet software, this easy-to-use accounting software enables users to gain complete control over their business accounting and finance. Besides handling accounting core processes, the software is designed to manage invoices, time sheets, planning, reporting, and inventories.</p>
                  <p class="card-text text-muted">Software security is over-the-par as it is supported by blockchain technology. Banana accounting software supports country-specific vat extensions. The software also allows business owners to forecast future budgets and plan finance effortlessly. Small and mid-sized businesses can make use of the free version of Banana Accounting, and for established organizations, there are professional and advanced plans.
                  </p>
              </div>


              <div class="card-body p-5 brand-body border-top">
                <h4 class="card-title mb-4">Core Features</h4>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Accounts Payable</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Bank Reconciliation</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Billing &amp; Invoicing</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Budgeting and Forecasting</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Financial Reporting</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Fund Accounting</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Payroll Management</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' />Project Accounting</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' /> Purchase Orders</span>
                <span className='badge rounded-pill text-primary px-3 bg-white mb-3 me-2 badge bg-primary'><FaCheckCircle className='me-1 text-primary' />Tax Management</span>
              </div>




              <div class="card-body p-5 brand-body border-top">
                <h4 class="card-title mb-3">Pricing</h4>
                <div className="d-flex justify-content-start gap-4">
                      <p className="fw-500 mt-3 pe-4 me-5">
                       <span className='d-block pb-3 text-muted'>Pricing Type</span>
                       <span>Flat Rate</span>
                      </p>
                      <p className="fw-500 mt-3 pe-4 me-5">
                      <span  className='d-block pb-3 text-muted'>Preferred Currency</span>
                      <span>USD ($)</span>
                      </p>

                      <p className="fw-500 mt-3 pe-4 me-5">
                      <span  className='d-block pb-3 text-muted'>Free Version</span>
                      <span>Yes</span>
                      </p>

                      <p className="fw-500 mt-3 pe-4 me-5">
                      <span  className='d-block pb-3 text-muted'>Payment Frequency</span>
                      <span>Monthly Payment</span>
                      </p>
                    </div>
              </div>



              <div class="card-body p-5 brand-body border-top">
                <h4 class="card-title mb-3">Pricing Plan</h4>
                <div className="d-flex justify-content-start gap-4">
                      <p className="fw-500 mt-3 border-end pe-5">
                       <span className='d-block pb-3 text-muted'>Basic</span>
                       <span className='fs-4 fw-600'>$ 25 <small className='fs-6 text-muted'>Monthly</small></span>
                      </p>
                      <p className="fw-500 mt-3 border-end pe-5">
                      <span  className='d-block pb-3 text-muted'>Gold</span>
                      <span className='fs-4 fw-600'>$ 125 <small className='fs-6 text-muted'>Monthly</small></span>
                      </p>

                      <p className="fw-500 mt-3 me-5">
                      <span  className='d-block pb-3 text-muted'>Premium</span>
                      <span className='fs-4 fw-600'>$ 300 <small className='fs-6 text-muted'>Monthly</small></span>
                      </p>
                    </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body pt-5">
                <h4 class="card-title mb-4">Customer Reviews</h4>
      <Row>
        {reviews.map((review) => (
          <Col md={12} key={review.id} className="mb-4">
            <Card className="shadow-sm border-0 rounded-3">
              <Card.Body className='p-4'>
                <div className="d-flex align-items-center">
                  <FaUserCircle size={40} className="me-3 text-secondary" />
                  <div>
                    <h6 className="mb-0">{review.name}</h6>
                    <small className="text-muted">Posted on: {review.date}</small>
                  </div>
                </div>
                <div className="mt-2">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={`me-1 ${
                        i < Math.floor(review.rating) ? "text-warning" : "text-muted"
                      }`}
                    />
                  ))}
                </div>
                <p className="mt-2 text-muted">{review.review}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
              </div>



        {/* FAQ Section */}
        <div class="card-body py-4">
                <h4 class="card-title mb-2">Faq's</h4>
              <div class="row justify-content-start text-start">
                <div class="col-sm-12 col-lg-12 col-xl-12">
                  <div className="accordion my-4" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button py-4 py-4"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          What is the purpose of this platform?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Our platform connects employers with talented candidates. It simplifies the hiring process by offering advanced tools for job posting, candidate screening, and communication.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className="accordion-button py-4 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          How do I post a job?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          To post a job, simply create an account, navigate to the job posting section, and fill in the required details about the job and your company. Your job will be visible to potential candidates immediately.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button py-4 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Can I filter candidates?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          Yes, our platform provides various filters to help you find the best candidates based on skills, experience, location, and more.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFour">
                        <button
                          className="accordion-button py-4 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          How do I purchase jobs or CV Database access online?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          To purchase jobs or CV Database access, log in to your account, navigate to the purchase section, and select the package that best fits your needs. Follow the prompts to complete the payment process.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFive">
                        <button
                          className="accordion-button py-4 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          How do I log in as a recruiter?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          To log in as a recruiter, go to the login page, enter your recruiter credentials (email and password), and click the "Log In" button. If you don’t have an account, you can register by clicking on the "Sign Up" button.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingSix">
                        <button
                          className="accordion-button py-4 collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          I have forgotten my password or am having trouble logging in.
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSix"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          If you have forgotten your password or are having trouble logging in, click the "Forgot Password" link on the login page. Follow the instructions to reset your password. If you continue to have issues, contact support for assistance.
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              </div>
      </div>
      <Footer />



      <Offcanvas show={showCanvas} onHide={handleClose} placement="end" style={{ width: 680 }}>
        <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue">
          <Offcanvas.Title>Write a Review</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-5 bg-light">
          <Container>
            <Form onSubmit={handleSubmit}>



              <Form.Group className="mt-4">
                <Form.Label>Can you write your review feedback</Form.Label>
                <Form.Control as="textarea" name="description" rows={3} value={formData.description} onChange={handleChange} required />
              </Form.Group>

              <Form.Group className="mt-4">
                <Form.Label className="m-0 p-0">Rate</Form.Label>
                <div>
                  {[...Array(5)].map((_, index) => (
                    <span key={index} onClick={() => handleRating(index)} style={{ cursor: "pointer", fontSize: "1.5rem", marginRight: "5px" }}>
                      {index < formData.rating ? <FaStar className="text-warning" /> : <FaRegStar className="text-warning" />}
                    </span>
                  ))}
                </div>
              </Form.Group>

              <Button variant="primary" type="submit" className="btn-lg mt-3" as={Link} to="/MyReviews">Submit Review</Button>
            </Form>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>





    </>

  );
};

export default ProductDetailedPage;
